import { observer } from 'mobx-react';
import React, { useCallback } from 'react';
import { useCheckoutStoreContext } from '../../context';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { defaultBranch } from 'src/constants/branches';
import { DELIVERY_TYPE } from 'src/constants/deliveryTypes';
import { ICheckoutDependencies } from 'src/mobx/checkoutStore/types';
import { localeStore } from 'src/mobx/localesStore';
import { modalStore } from 'src/mobx/modalStore';
import { IBranch } from 'src/types/branches';
import CopyButton from 'src/view/components/Controls/CopyButton/CopyButton';
import Icon from 'src/view/components/Controls/Icon/Icon';
import FakePicker from 'src/view/components/Controls/Pickers/FakePicker/FakePicker';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

interface IProps {
  error?: boolean;
}

const CheckoutAddress: React.FC<IProps> = observer((props: IProps): JSX.Element => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  const changeDeliveryData = useCallback((branch: IBranch | undefined, location: ICheckoutDependencies['location'], delivery_type: DELIVERY_TYPE) => {
    checkoutStore.selectBranch(branch || defaultBranch);
    checkoutStore.selectLocation(location);
    if (delivery_type) checkoutStore.changeDeliveryType(delivery_type);
  }, []);

  const openDeliveryPicker = useCallback(() => {
    modalStore.openDeliveryType({
      editable: checkoutStore.isDraft,
      location: checkoutStore.dependencies.location,
      customer: checkoutStore.dependencies.customer?.id,
      branch: checkoutStore.dependencies.branch,
      delivery_type: checkoutStore.params.delivery_type === 'd' ? DELIVERY_TYPE.DELIVERY : DELIVERY_TYPE.PICKUP,
      onChange: changeDeliveryData,
    });
  }, [
    checkoutStore.isDraft,
    checkoutStore.dependencies.location,
    checkoutStore.dependencies.customer,
    checkoutStore.dependencies.branch,
    checkoutStore.params.delivery_type,
    changeDeliveryData,
  ]);

  return (
    <div className="d-flex align-items-center flex-grow-1 full-width mb-3">
      <Text type={TEXT.ORDER_FIELD} text="Address" required />
      {/* address */}
      <FakePicker
        onClick={openDeliveryPicker}
        disabled={!checkoutStore.isDraft}
        error={props.error}
        placeholder={localeStore.t('choose_address')}
        value={checkoutStore.dependencies.location?.address || ''}
        className="checkout-address__picker"
        textClassName="family-medium"
        placeholderClassName="family-medium"
        wrapperClassName="checkout-address__picker__wrapper"
      />
      {/* copy to clipboard button */}
      <CopyButton data={checkoutStore.dependencies.location?.address} tooltipMessage="copied_to_clickboard" />
      {/* map modal open button */}
      <Icon name={Icons.Map} onPress={openDeliveryPicker} size={24} className="ml-4 color-mainblue text-pointer" />
    </div>
  );
});

export default CheckoutAddress;
